export function addInstitutionToMealsToRelase(mealsToRelase) {
  return mealsToRelase.map((meal) => {
    const institution = {
      name: meal?.institutionName,
      shortName: meal?.institutionShortName,
      id: meal?.institutionId,
    };

    return {
      ...meal,
      ...(meal?.institutionName ? { institution } : {}),
    };
  });
}
